import React from 'react';

import { angularizeWithProviders, LbSnackbarProvider } from '../../providers';

/**
 * Use to create one instance of the snackbar notification provider, to show toast notification in the app
 * Not use useSneakbar hook, use enqueueSnackbar and closeSnackbar from notistack
 */
const NgzSnackbarNotification = () => {
  return <LbSnackbarProvider />;
};

angularizeWithProviders(NgzSnackbarNotification, 'ngzSnackbarNotification', {});

export { NgzSnackbarNotification };
